import React, { useState } from "react";
import { Button, Message, Input } from "../../../../BP2Components";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { useIntl } from "react-intl";

const BannerSettings = ({ value }) => {
   const dispatch = useDispatch();
   const intl = useIntl();
   const [settings, setSettings] = useState({
      ...value
   });
   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };
   const handleChange = (e) => {
      setSettings({ ...settings, [e.target.name]: e.target.value });
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="btnSet" className="widget-settings__inner">
                  <label
                     key="bannerWidgetTitleTranslationKey"
                     className="widget-settings__inner__label"
                  >
                     <IntlMessages id="settings.bannerWidgetTitleTranslationKey" />:
                     <Input
                        type="bannerWidgetTitleTranslationKey"
                        name="bannerWidgetTitleTranslationKey"
                        defaultValue={value.bannerWidgetTitleTranslationKey}
                        onChange={handleChange}
                        style={{ width: "400px" }}
                     />
                  </label>{" "}
                  <label key="buttonTitleTranslationKey" className="widget-settings__inner__label">
                     <IntlMessages id="settings.buttonTitleTranslationKey" />:
                     <Input
                        type="buttonTitleTranslationKey"
                        name="buttonTitleTranslationKey"
                        defaultValue={value.buttonTitleTranslationKey}
                        onChange={handleChange}
                        style={{ width: "400px" }}
                     />
                  </label>
                  <label key="url" className="widget-settings__inner__label">
                     <IntlMessages id="settings.url" />:
                     <Input
                        // type="url"
                        name="url"
                        style={{ width: "400px" }}
                        onChange={handleChange}
                        defaultValue={value.url}
                     />
                  </label>
                  <label key="webKey" className="widget-settings__inner__label">
                     <IntlMessages id="settings.webKey" />:
                     <Input
                        // type="url"
                        name="webKey"
                        style={{ width: "400px" }}
                        onChange={handleChange}
                        defaultValue={value.webKey}
                     />
                  </label>{" "}
                  <label key="widgetKey" className="widget-settings__inner__label">
                     <IntlMessages id="settings.widgetKey" />:
                     <Input
                        // type="url"
                        name="widgetKey"
                        style={{ width: "400px" }}
                        onChange={handleChange}
                        defaultValue={value.widgetKey}
                     />
                  </label>
               </div>
               <Button key="btn" buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.save" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default BannerSettings;
